import { Star } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useSite } from "@/context/SiteContext";

export const Reviews = () => {
  const { reviews } = useSite();
  if (!reviews || reviews.length === 0) return null;

  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <Eyebrow>Guest Stories</Eyebrow>
            <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight">Words from the island</h2>
          </div>
          <p className="max-w-sm text-sm text-seastone leading-relaxed">
            Notes left by travellers who stayed slow with us.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-5" data-testid="reviews-grid">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.1}>
              <figure
                className="h-full bg-white rounded-3xl border border-ink/10 p-7 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(14,27,46,0.12)]"
                data-testid={`review-card-${r.id}`}
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="flex gap-1" aria-label={`${r.rating} out of 5 stars`}>
                    {Array.from({ length: 5 }, (_, s) => (
                      <Star key={s} size={15} className={s < r.rating ? "fill-gold text-gold" : "text-ink/20"} />
                    ))}
                  </div>
                  {r.source && (
                    <span
                      className="text-[10px] font-mono uppercase tracking-[0.16em] text-azure bg-azure/10 rounded-full px-3 py-1"
                      data-testid={`review-source-${r.id}`}
                    >
                      via {r.source}
                    </span>
                  )}
                </div>
                <blockquote className="mt-4 flex-1 font-serif text-lg leading-relaxed text-ink/85">
                  "{r.text}"
                </blockquote>
                <figcaption className="mt-5 pt-4 border-t border-ink/10">
                  <p className="text-sm font-medium" data-testid={`review-name-${r.id}`}>{r.name}</p>
                  {r.origin && <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-seastone mt-0.5">{r.origin}</p>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
